// bron: https://codepen.io/yaphi1/pen/KpbRZL
const countdown = () => {
	const selector = '.js-countdown';
	const endtext = 'Wilt u nogmaals uw WINcode activeren?';

	if ($(selector).length === 0) {
		return;
	}

	const timeInMinutes = 10;
	const currentTime = Date.parse(new Date());
	const deadline = new Date(currentTime + timeInMinutes * 60 * 1000);

	const timeRemaining = (endtime) => {
		const t = Date.parse(endtime) - Date.parse(new Date());
		let seconds = Math.floor((t / 1000) % 60);
		let minutes = Math.floor((t / 1000 / 60) % 60);
		seconds = seconds.toString().length === 2 ? seconds : `0${seconds}`;
		minutes = minutes.toString().length === 2 ? minutes : `0${minutes}`;
		return {
			total: t,
			minutes,
			seconds
		};
	};

	const runClock = (s, endtime) => {
		let timeinterval = null;
		const clock = $(s);
		const updateClock = () => {
			const t = timeRemaining(endtime);
			clock.text(`${t.minutes}:${t.seconds}`);
			if (t.total <= 0) {
				clearInterval(timeinterval);
				clock.parent().text(endtext);
			}
		};
		updateClock(); // run function once at first to avoid delay
		timeinterval = setInterval(updateClock, 1000);
	};

	runClock(selector, deadline);
};

export default countdown;
